// extracted by mini-css-extract-plugin
export default {"price":"X9-z","onSale":"Y9-z","msrpLabelPrice":"Z9-z","msrpLabel":"_9-z","originalPrice":"a--z","percentOff":"b--z"};